import { AxiosError } from 'axios';

export const getErrorMessage = (
  err: unknown,
  fallback = 'An unexpected error occurred',
): string => {
  const errorMessage =
    (err as AxiosError).response?.data &&
    typeof (err as AxiosError).response?.data === 'object'
      ? ((err as AxiosError).response?.data as { error?: string }).error
      : undefined;
  return errorMessage || fallback;
};
